import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { CampaignStockVin } from '../../../../../core/interfaces/campaign-stock-vins';

@Component({
  selector: 'app-vin-selector',
  standalone: true,
  imports: [CommonModule, TranslateModule, FormsModule],
  templateUrl: './vin-selector.component.html',
  styleUrl: './vin-selector.component.css'
})
export class VinSelectorComponent {
  @Input() availableVins: CampaignStockVin[] = [];
  @Output() vinSelected = new EventEmitter<CampaignStockVin>();
  @Output() closeSelector = new EventEmitter<void>();

  searchTerm = '';
  filterWorkshop = '';
  filterState = '';

  get workshops(): string[] {
    const set = new Set<string>();
    this.availableVins.forEach(v => {
      if (v.workshop_name) set.add(v.workshop_name);
    });
    return Array.from(set).sort();
  }

  get states(): string[] {
    const set = new Set<string>();
    this.availableVins.forEach(v => {
      if (v.state) set.add(v.state);
    });
    return Array.from(set).sort();
  }

  get filteredVins(): CampaignStockVin[] {
    let result = this.availableVins;

    if (this.filterWorkshop) {
      result = result.filter(v => v.workshop_name === this.filterWorkshop);
    }

    if (this.filterState) {
      result = result.filter(v => v.state === this.filterState);
    }

    if (this.searchTerm) {
      const term = this.searchTerm.toUpperCase();
      result = result.filter(v =>
        v.vin.toUpperCase().includes(term) ||
        (v.license_plate && v.license_plate.toUpperCase().includes(term)) ||
        (v.workshop_name && v.workshop_name.toUpperCase().includes(term)) ||
        (v.supplier_reference && v.supplier_reference.toUpperCase().includes(term)) ||
        (v.colour && v.colour.toUpperCase().includes(term)) ||
        (v.external_state && v.external_state.toUpperCase().includes(term)) ||
        (v.notes && v.notes.toUpperCase().includes(term))
      );
    }

    return result;
  }

  selectVin(vin: CampaignStockVin): void {
    this.vinSelected.emit(vin);
  }

  close(): void {
    this.closeSelector.emit();
  }
}
